import { photoSubCategories } from '../../constants/lib/constants';

/**
 * Function to take the order and the data from UXL and sort the response in the predefined order
 * @param nonCategoryImages : uxl response being provided as input
 * @returns sortedArray that will have response in sorted order
 */
export const sortImagesUXLResponseWithCategories = (nonCategoryImages: { categoryCode: string }[]) => {
  const orderMap: { [key: string]: number } = {};
  photoSubCategories.forEach((code, index) => {
    orderMap[code] = index;
  });

  const sortedArray = nonCategoryImages.sort((x, y) => {
    //Checking if the category from predefined order exists if not then it will be placed at the end
    const indexX = orderMap[x.categoryCode] !== undefined ? orderMap[x.categoryCode] : Infinity;
    const indexY = orderMap[y.categoryCode] !== undefined ? orderMap[y.categoryCode] : Infinity;
    return indexX - indexY;
  });
  return sortedArray;
};
